export default __webpack_public_path__ + "static/media/video-thumbnail.efe45251.svg";